module.exports = __webpack_public_path__ + "static/media/homestay_japan.6fb08d1e.webp";